export class FileUpload {
  id?: string | undefined
  name: string
  status?: string | undefined
  url?: string | undefined
  updatedAt?: Date | undefined
  lastUsedAt?: Date | undefined
  progress?: number;
  fileSize?: number;
  fileType?: string;
  imageAnalysis?: boolean;

  constructor(id: string | undefined, name: string, status: string | undefined, url: string | undefined, updatedAt?: Date | undefined, lastUsedAt?: Date | undefined, fileSize?: number, imageAnalysis?: boolean) {
    this.id = id
    this.name = name
    this.status = status
    this.url = url
    this.updatedAt = updatedAt
    this.lastUsedAt = lastUsedAt
    this.fileSize = fileSize
    this.imageAnalysis = imageAnalysis
  }
}
